const DataAnalysisVideoIntro = [
    {
        key : 1,
        title : "Introduction to Power BI Desktop",
        video : "https://firebasestorage.googleapis.com/v0/b/brainanalytics-pk.appspot.com/o/VID_20230317_225355.mp4?alt=media&token=c0a7b835-78db-41fa-a1fd-10a1a89fe085"
    },
    {
        key : 2,
        title : "Power BI Vs Excel",
        video : ""
    },
    {
        key : 3,
        title : "Power BI Installation",
        video : ""
    },
    {
        key : 4,
        title : "Power BI Interface",
        video : ""
    },
    {
        key : 5,
        title : "Power BI Workflow",
        video : ""
    },
    {
        key : 6,
        title : "Sources for Knowledge",
        video : ""
    },
    
];
export default DataAnalysisVideoIntro;